module.exports = __webpack_public_path__ + "img/bread-easypay-research.e538c37e.png";